import { render, staticRenderFns } from "./HealthCheck20.vue?vue&type=template&id=47f897ed&scoped=true&"
import script from "./HealthCheck20.vue?vue&type=script&lang=js&"
export * from "./HealthCheck20.vue?vue&type=script&lang=js&"
import style0 from "./HealthCheck20.vue?vue&type=style&index=0&id=47f897ed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f897ed",
  null
  
)

export default component.exports